/* eslint-disable prefer-template */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return, no-param-reassign */
import axios from "axios";

import {
    createStore,
    createHook,
    createContainer,
    createSubscriber,
} from "react-sweet-state";


const Store = createStore({
    initialState: {
    },
    actions: {
        getStake:
            (param) =>
                async ({ setState, getState }) => {
                    return new Promise((resolve, reject) => {
                        axios.get(`https://api.kingdomstarter.io/api/staking-balances/tier/${param}`)
                            .then((res) => {
                                resolve(res?.data)
                            })
                            .catch((err) => {
                                reject(err)
                            })
                    });
                },
    },
    name: "Store",
});

export const useHook = createHook(Store);
export const Container = createContainer(Store, {
    onInit:
        () =>
            ({ setState }, props) => {
                setState({ ...props });
            },
});
export const Subscriber = createSubscriber(Store);
